import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';

import { IsAssetPurchasedResponse, PurchasesProps, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';

import { queryKeys } from '../queryKeys';

export const useInvalidatePurchases = () => {
    const queryClient = useQueryClient();

    const invalidatePurchasesQuery = () => {
        queryClient.invalidateQueries(queryKeys.myPurchases);
        queryClient.invalidateQueries(queryKeys.myRentals);
        queryClient.invalidateQueries(QUERY_KEYS.availableSubscriptions);
        queryClient.invalidateQueries(QUERY_KEYS.mySubscriptions);
        queryClient.invalidateQueries(QUERY_KEYS.blockers);
        queryClient.invalidateQueries(QUERY_KEYS.editions);
        queryClient.invalidateQueries(QUERY_KEYS.isPurchased);
        queryClient.invalidateQueries(QUERY_KEYS.entitledSubscriptions);
    };

    return { invalidatePurchasesQuery };
};

const useIsAssetPurchasedQuery = (
    asset: PurchasesProps,
    options?: UseQueryOptions<unknown, Error, IsAssetPurchasedResponse>
) => {
    const { fetchIsAssetPurchased } = usePurchaseData();
    const reactQuery = getRuntimeConfig('reactQuery');

    return useQuery<unknown, Error, { isPurchased: boolean }>(
        queryKeys.isAssetPurchased(asset?.id),
        () => fetchIsAssetPurchased(asset),
        {
            staleTime: reactQuery.staleTime.short,
            enabled: Boolean(asset),
            ...options,
        }
    );
};

export default useIsAssetPurchasedQuery;
